import style from './style.module.scss'
import { Text } from '@crossfit/design-system'

type Props = {
  imageUrl?: string
}

const LogoView = ({ imageUrl }: Props) => {
  return (
    <div className={style.logoContainer}>
      {imageUrl ? (
        <img src={imageUrl} className={style.logo} />
      ) : (
        <div className={style.logoDefault}>
          <Text as='p' type='body' size='sm'>
            No Logo
          </Text>
          <Text as='p' type='body' size='sm'>
            Added
          </Text>
        </div>
      )}
    </div>
  )
}

export default LogoView
